
import {Component, Prop, Vue} from "vue-property-decorator";
import {IMessage} from "../../../server/src/modules/shared-interfaces";
import {EventBus} from "../EventBus";

@Component
export default class FlashMessage extends Vue {
    @Prop() message!: IMessage;

    removeMessage(id: string) {
        EventBus.$emit("message.remove", id)
    }
}
